import { Pagination } from '@warp-ds/react/components/pagination';
import type { Filters, ResultDataStats } from '@/domain';

type PaginationProps = {
    stats: ResultDataStats;
    onFilterChanged: (filters: Filters) => void;
};

export const PaginationWrapper = ({ stats, onFilterChanged }: PaginationProps) => {
    const verifyPageNumber = (page: number): number => {
        if (page < 1 || !stats.totalPages) {
            return 1;
        }
        if (page > stats.totalPages) {
            return stats.totalPages;
        }
        return page;
    };

    const handleChange = (page: number): void => {
        const updatedPage = verifyPageNumber(page);
        onFilterChanged({ page: updatedPage });
        if (document.activeElement) {
            // @ts-expect-error
            document.activeElement.blur();
        }
    };

    const currentPage = stats.currentPage ? stats.currentPage : 1;
    const totalPages = stats.totalPages ? stats.totalPages : 1;

    if (totalPages < 2) {
        return <div data-testid="emptyPage" />;
    }
    return <Pagination currentPage={currentPage} lastPage={totalPages} createHref={() => '#'} onChange={handleChange} className="my-24" />;
};
